/**
 * Event constants for the Hyve Phaser Plugin
 */
export const HyveEvents = {
  /** Fired when authentication completes (success or failure) */
  AUTHENTICATED: 'hyve-authenticated',
  /** Fired when telemetry is successfully sent */
  TELEMETRY_SENT: 'hyve-telemetry-sent',
  /** Fired when telemetry fails to send */
  TELEMETRY_ERROR: 'hyve-telemetry-error',
  /** Fired when plugin is initialized */
  PLUGIN_READY: 'hyve-plugin-ready',
  /** Fired when an API call is successful */
  API_CALL_SUCCESS: 'hyve-api-call-success',
  /** Fired when an API call fails */
  API_CALL_ERROR: 'hyve-api-call-error',
} as const;

export type HyveEventType = typeof HyveEvents[keyof typeof HyveEvents];